var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27967 8.97947C6.21967 8.97947 6.97301 9.74014 6.97301 10.6868V12.9595C6.97301 13.8995 6.21967 14.6661 5.27967 14.6661H3.02634C2.09301 14.6661 1.33301 13.8995 1.33301 12.9595V10.6868C1.33301 9.74014 2.09301 8.97947 3.02634 8.97947H5.27967ZM12.9731 8.97947C13.9064 8.97947 14.6664 9.74014 14.6664 10.6868V12.9595C14.6664 13.8995 13.9064 14.6661 12.9731 14.6661H10.7197C9.77974 14.6661 9.02641 13.8995 9.02641 12.9595V10.6868C9.02641 9.74014 9.77974 8.97947 10.7197 8.97947H12.9731ZM5.27967 1.33301C6.21967 1.33301 6.97301 2.09967 6.97301 3.04034V5.31301C6.97301 6.25967 6.21967 7.01967 5.27967 7.01967H3.02634C2.09301 7.01967 1.33301 6.25967 1.33301 5.31301V3.04034C1.33301 2.09967 2.09301 1.33301 3.02634 1.33301H5.27967ZM12.9731 1.33301C13.9064 1.33301 14.6664 2.09967 14.6664 3.04034V5.31301C14.6664 6.25967 13.9064 7.01967 12.9731 7.01967H10.7197C9.77974 7.01967 9.02641 6.25967 9.02641 5.31301V3.04034C9.02641 2.09967 9.77974 1.33301 10.7197 1.33301H12.9731Z",
    fill: "#1E4133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b3bc3dbe269adba57d28712624f698f1.svg";
export { ForwardRef as ReactComponent };